<template>
  <div v-if="showSidebar" class="sidebar-backdrop" @click="showSidebar = false"></div>

  <nav v-bind="$attrs" class="sidebar" :class="{ 'sidebar-open': showSidebar }" ref="sidebarRef">
    <!-- Sidebar Header -->
    <div class="sidebar-head">
      <div class="sidebar-title">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
        Navigation
      </div>
      <button class="close-sidebar-btn" @click="showSidebar = false">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>

    <!-- Menu -->
    <div class="sidebar-body">
      <button v-if="privilage() == 'admin'" class="nav-item" @click="navigateTo('/')">
        <span class="nav-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12L12 3l9 9M5 10v9a1 1 0 001 1h4v-5h4v5h4a1 1 0 001-1v-9"/></svg>
        </span>
        <span>Tableau de bord</span>
      </button>

      <!-- Posts Section -->
      <div v-if="privilage() == 'admin'" class="nav-section">
        <div class="nav-section-label">Postes</div>
        <div class="posts-list">
          <button
            v-for="(sub, i) in menuItems[0].submenu"
            :key="i"
            class="post-btn"
            @click="navigateTo(`/pointage/main/${sub.Post_name}`)"
          >
            <span class="post-dot"></span>
            {{ sub.Post_name }}
          </button>
        </div>
      </div>

      <!-- General Users Menu -->
      <div v-if="privilage() == 'admin'" class="nav-section user-section">
        <div class="nav-section-label">Personnel</div>
        <button class="nav-item" @click="navigateTo('/pointage/pointage')">
          <span class="nav-icon nav-icon-blue">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          </span>
          <span>Pointage</span>
        </button>
        <button class="nav-item" @click="navigateTo('/pointage/encours')">
          <span class="nav-icon nav-icon-purple">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
          </span>
          <span>En cours de travail</span>
        </button>
        <button class="nav-item" @click="navigateTo('/pointage/journee')">
          <span class="nav-icon nav-icon-green">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h18"/><path d="m9 16 2 2 4-4"/></svg>
          </span>
          <span>Résumé journée</span>
        </button>
        <button class="nav-item" @click="navigateTo('/pointage/dossiers')">
          <span class="nav-icon nav-icon-teal">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          </span>
          <span>Dossiers employés</span>
        </button>
        <button class="nav-item" @click="navigateTo('/pointage/respect-horaires')">
          <span class="nav-icon nav-icon-blue">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
          </span>
          <span>Respect horaires</span>
        </button>
        <button class="nav-item" @click="navigateTo('/pointage/notifications')">
          <span class="nav-icon nav-icon-blue">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 8a6 6 0 1 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
          </span>
          <span>Notifications</span>
        </button>
      </div>

      <!-- Admin Menu -->
      <div v-if="privilage() == 'admin'" class="nav-section admin-section">
        <div class="nav-section-label">Administration</div>
        <button class="nav-item" @click="navigateTo('/pointage/remarques')">
          <span class="nav-icon nav-icon-amber">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
          </span>
          <span>Remarques</span>
        </button>
        <button class="nav-item" @click="navigateTo('/pointage/avances')">
          <span class="nav-icon nav-icon-green">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>
          </span>
          <span>Masse Salariale</span>
        </button>
        <button class="nav-item" @click="navigateTo('/pointage/planning')">
          <span class="nav-icon nav-icon-teal">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          </span>
          <span>Planning RH</span>
        </button>
      </div>
    </div>
  </nav>

  <!-- Mobile Toggle -->
  <button v-if="!showSidebar" class="sidebar-toggle" @click="showSidebar = true">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
  </button>
</template>

<script>
export default {
  inject: ['posts', 'privilage'],
  name: 'AppLeftSideBar',
  inheritAttrs: false,
  emits: ['submenuClick'],
  data() {
    return {
      showSidebar: false,
      menuItems: [{ title: 'Posts', submenu: [], expanded: false }],
    };
  },
  mounted() {
    this.fetchPosts();
    window.addEventListener('posts-updated', this.fetchPosts);
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeUnmount() {
    window.removeEventListener('posts-updated', this.fetchPosts);
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    handleOutsideClick(event) {
      const sidebar = this.$refs.sidebarRef;
      const toggleBtn = event.target.closest('.sidebar-toggle');
      if (this.showSidebar && sidebar && !sidebar.contains(event.target) && !toggleBtn) {
        this.showSidebar = false;
      }
    },
    navigateTo(url) {
      this.showSidebar = false;
      this.$router.push(url.replace(/^\/pointage/, '') || '/');
    },
    async fetchPosts() {
      try {
        const response = await fetch('/api-pointage/fetchposts', {
          credentials: 'include',
          cache: 'no-store',
        });
        if (!response.ok) throw new Error('Failed');
        const data = await response.json();
        this.menuItems[0].submenu = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error(error);
        this.menuItems[0].submenu = [];
      }
    },
  },
};
</script>

<style>
.sidebar {
  width: var(--sidebar-width);
  background: var(--white);
  border-right: 1px solid var(--border);
  height: calc(100vh - var(--header-height));
  position: fixed;
  top: var(--header-height);
  left: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  z-index: 999;
  transition: transform var(--transition-slow);
}

.sidebar-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 14px 10px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.sidebar-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'DM Sans', sans-serif;
  font-size: 12px; font-weight: 900;
  color: var(--gray-600);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.sidebar-title svg { width: 14px; height: 14px; color: var(--primary); }

.close-sidebar-btn {
  display: none;
  width: 28px; height: 28px;
  border: none; border-radius: 6px;
  background: var(--gray-100);
  color: var(--gray-500);
  cursor: pointer;
  align-items: center; justify-content: center;
  transition: all var(--transition);
}
.close-sidebar-btn svg { width: 14px; height: 14px; }
.close-sidebar-btn:hover { background: var(--danger-bg); color: var(--danger); }

.sidebar-body {
  flex: 1;
  padding: 10px 10px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 20px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  background: transparent;
  border-radius: var(--radius-sm);
  color: var(--gray-600);
  font-family: 'DM Sans', sans-serif;
  font-size: 13px; font-weight: 700;
  cursor: pointer;
  text-align: left;
  transition: all var(--transition);
}
.nav-item:hover {
  background: #f8fafc;
  color: var(--gray-900);
}

.nav-icon {
  width: 28px; height: 28px;
  border-radius: 7px;
  background: #f8fafc;
  border: 1px solid var(--border);
  color: var(--gray-500);
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  transition: all var(--transition);
}
.nav-icon svg { width: 14px; height: 14px; }
.nav-item:hover .nav-icon {
  background: #eff6ff;
  border-color: rgba(37, 99, 235, 0.24);
  color: var(--primary);
}

.nav-icon-blue,
.nav-icon-amber,
.nav-icon-green,
.nav-icon-purple,
.nav-icon-teal {
  background: #f8fafc;
  color: var(--gray-500);
}

.nav-section {
  margin-top: 6px;
}

.nav-section-label {
  padding: 9px 10px 5px;
  font-size: 10.5px; font-weight: 900;
  color: var(--gray-400);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.posts-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.post-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 7px 10px 7px 16px;
  border: none;
  background: transparent;
  border-radius: var(--radius-sm);
  font-family: 'DM Sans', sans-serif;
  font-size: 13px; font-weight: 700;
  color: var(--gray-600);
  cursor: pointer;
  text-align: left;
  transition: all var(--transition);
}
.post-btn:hover {
  background: #f8fafc;
  color: var(--gray-900);
}
.post-dot {
  width: 6px; height: 6px;
  border-radius: 50%;
  background: var(--primary);
  flex-shrink: 0;
  box-shadow: none;
}

.admin-section {
  margin-top: 4px;
  padding-top: 6px;
  border-top: 1px solid var(--border);
}

.sidebar-toggle {
  display: none;
  position: fixed;
  top: calc(var(--header-height) + 10px);
  left: 12px;
  z-index: 1001;
  width: 40px; height: 40px;
  background: var(--white);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  cursor: pointer;
  align-items: center; justify-content: center;
  box-shadow: var(--shadow-md);
  transition: all var(--transition);
}
.sidebar-toggle svg { width: 18px; height: 18px; color: var(--gray-600); }
.sidebar-toggle:hover { background: var(--gray-100); }

.sidebar-backdrop {
  display: none;
}

@media (max-width: 768px) {
  .sidebar-backdrop {
    display: block;
    position: fixed;
    inset: var(--header-height) 0 0 0;
    background: rgba(15, 23, 42, 0.42);
    backdrop-filter: blur(2px);
    z-index: 1090;
  }

  .sidebar {
    transform: translateX(-110%);
    width: min(84vw, 300px);
    max-width: 300px;
    box-shadow: 18px 0 45px rgba(15, 23, 42, 0.22);
    z-index: 1100;
    padding-bottom: env(safe-area-inset-bottom, 0px);
    border-right: 1px solid rgba(213, 222, 238, 0.9);
  }
  .sidebar.sidebar-open { transform: translateX(0); }
  .sidebar-toggle {
    display: flex;
    top: calc(var(--header-height) + 10px);
    left: 12px;
    width: 48px;
    height: 48px;
    border-radius: 12px;
  }
  .close-sidebar-btn { display: flex; }

  .nav-item,
  .post-btn {
    min-height: 44px;
  }
}
</style>
